import { CustomerDto } from "@maia/shared";
import { useAppForm } from "../form/dynamic-form/dynamic-form";
import * as v from 'valibot';
import { IconEnvelopeAlt, IconPhone, IconSave } from "@maia/icons";
import { Button, getErrors } from "@maia/ui";
import { validatePhonenumber } from "@maia/utils";

type EditContactFormProps = {
  customer: CustomerDto;
  onSubmit: (value: { old_email: string; guid: string; email: string; phone?: string }) => void;
  isPending: boolean;
}

export function EditContactForm(props: EditContactFormProps) {
  const { customer, onSubmit, isPending } = props;

  const form = useAppForm({
    defaultValues: {
      email: customer.consumer.email,
      phone: customer.consumer.phone,
    },
    onSubmit: ({ value }) => {
      onSubmit({
        old_email: customer.consumer.email ?? '',
        guid: customer.guid,
        email: value.email,
        phone: value.phone,
      });
    },
  });

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
        event.stopPropagation();
        form.handleSubmit();
      }}
      className="grid grid-cols-12 gap-24 col-span-full"
    >
      <form.AppField
        name="email"
        validators={{
          onChange: v.pipe(
            v.string('Veld is verplicht'),
            v.minLength(1, 'Veld is verplicht'),
            v.email('Dit lijkt niet op een geldig email adres'),
          ),
        }}
      >
        {(field) => {
          return (
            <field.TextField
              label="Email"
              className="col-span-full"
              inputOverrides={{
                fieldSize: 'large',
                placeholder: 'Voorbeeld@email.nl',
                icon: <IconEnvelopeAlt />,
              }}
              error={getErrors(field)}
            />
          );
        }}
      </form.AppField>

      <form.AppField
        name="phone"
        validators={{
          onChange: v.pipe(
            v.string('Veld is verplicht'),
            v.minLength(1, 'Veld is verplicht'),
            v.custom((value) => {
              if (typeof value !== 'string') {
                return false;
              }

              return validatePhonenumber(value);
            }, 'Telefoonnummer is niet geldig'),
          ),
        }}
      >
        {(field) => {
          return (
            <field.TextField
              label="Telefoonnummer"
              className="col-span-full"
              inputOverrides={{
                fieldSize: 'large',
                placeholder: '0612345678',
                icon: <IconPhone />,
              }}
              error={getErrors(field)}
            />
          );
        }}
      </form.AppField>

      <div className="col-span-full flex justify-end">
        <form.Subscribe
          selector={(state) => {
            return [state.canSubmit, state.isSubmitting, state.isValid];
          }}
        >
          {([canSubmit, isSubmitting, isValid]) => (
            <Button
              type="submit"
              intent="cta"
              iconLeft={IconSave}
              isDisabled={!canSubmit || isSubmitting || isPending || !isValid}
              isLoading={isPending}
            >
              Wijziging opslaan
            </Button>
          )}
        </form.Subscribe>
      </div>
    </form>
  )
}
